<!-- 루트 컴포넌트. 라우터 아웃렛만 마운트하고 레이아웃은 각 페이지가 직접 구성한다 -->
<template>
  <RouterView />
</template>

<script setup lang="ts"></script>
